import { type FieldValues, type UseControllerProps, useFormContext } from 'react-hook-form';

import { DatePicker, type DatePickerProps } from '@wf/components';

import { type LicenseFieldProps } from './LicenseFieldController';

import { useLicenseController } from '../../hooks/useLicenseController';

import { formatDate } from '../../../../helpers/dateHelpers';

export const LicenseDateField = ({
  name,
  defaultValue,
  configName,
  featureFlag,
  viewMode,
  rules,
  shouldUnregister,
  control,
  disabled,
  ...rest
}: Omit<DatePickerProps, 'onChange'> &
  LicenseFieldProps &
  UseControllerProps<FieldValues, any> & { onChange?: (date: Date) => void }) => {
  const { control: contextControl } = useFormContext();

  const {
    field: { value, onChange, onBlur, ...fieldRest },
    computedProps,
    config,
  } = useLicenseController({
    name,
    configName,
    featureFlag,
    control: control ?? contextControl,
    defaultValue: defaultValue ?? null,
    rules,
    shouldUnregister,
    viewMode,
    disabled,
  });

  const handleChange: typeof rest.onChange = (...args) => {
    onChange(...args);

    if ('onChange' in rest && typeof rest.onChange === 'function') {
      rest.onChange(...args);
    }
  };

  if (config.isHidden) {
    return <></>;
  }

  return (
    <DatePicker
      {...fieldRest}
      {...computedProps}
      {...rest}
      ref={(ref) => {
        fieldRest.ref({
          focus: ref?.input?.inputElement?.focus.bind(ref?.input?.inputElement) ?? (() => null),
        });
      }}
      valueView={value ? formatDate(value as Date) : '-'}
      onChange={handleChange}
    />
  );
};
